<script>
    import { createEventDispatcher } from 'svelte'
    import { Label } from 'sveltestrap'
    import ChromePicker from 'svelte-color/Chrome.svelte'
    import ChromePickerSlim from 'svelte-color/ChromeSlim.svelte'
    import Required from './Required.svelte'
    import DisableLock from '../fanxLight/DisableLock.svelte'

    export let context
    export let formKey
    export let keypath
    export let label
    export let required
    export let value
    export let slim
    export let defaultValue
    export let disabled

    $: formKeypath = `${formKey}.${keypath}`

    let startColor
    $: {
        if (value) {
            startColor = value
        } else if (defaultValue) {
            startColor = defaultValue
        } else {
            startColor = '#000000'
        }
    }

    const dispatch = createEventDispatcher()
    function update(event) {
        value = event.detail[0] === '#' ? event.detail.split('#')[1] : event.detail
        dispatch('change', { formKey, keypath, value: value.toLowerCase(), context })
    }
</script>

<div
    class="component-form-field component-form-field-color"
    on:focus
    on:blur
    >
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>

    {#if slim}
    <!--
        NOTE: Setting the disable property ChromePickerSlim does't work.
              To get around this disabling is done through CSS, an absolutely
              positioned div is conditionally rendered which sits on top of the picker.
     -->
    <div class="color-picker">
        <ChromePickerSlim
            bind:value
            forcePoundSign="{true}"
            upcaseOutput="{true}"
            disableAlpha={true}
            on:input={update}
            startColor={startColor}
        />
        {#if disabled}
            <div class="disable-lock-slim">
                <div class="lock-position-slim">
                    <DisableLock />
                </div>
            </div>
        {/if}
    </div>
    {:else}
        <ChromePicker
            bind:value
            disableAlpha={true}
            on:input={update}
            startColor={startColor}
        />
        {#if disabled}
            <div class="disable-lock">
                <div class="lock-position">
                    <DisableLock />
                </div>
            </div>
        {/if}
    {/if}
</div>

<style>
    .component-form-field-color{
        position: relative;
    }

    .color-picker {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        align-items: center;
    }

    .disable-lock-slim,
    .disable-lock {
        position: absolute;
        display: flex;
        align-items: center;
        display: flex;
        justify-content: flex-end;
        width: 100%;
        z-index: 9;
        background-color: rgba(0, 0, 0, .1);
    }
    
    .disable-lock-slim {
        height: 70%;
    }

    .disable-lock {
        height: 92%;
        top: 1.45rem;
    }

    .lock-position,
    .lock-position-slim {
        position: relative;
        right: .8rem;
    }

    .lock-position-slim {
        top: -.1rem;
    }

    .lock-position {
        bottom: -5.1rem;
    }
</style>